import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          minHeight: "100vh", background: "#FAF8F3", fontFamily: "'Montserrat', system-ui, sans-serif",
        }}>
          <div style={{ textAlign: "center", maxWidth: 440, padding: 40 }}>
            <div style={{
              width: 56, height: 56,
              background: "linear-gradient(135deg, #B91C1C, #991B1B)",
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 24, color: "#fff", margin: "0 auto 20px",
            }}>!</div>
            <div style={{ fontSize: 22, fontWeight: 500, color: "#0C1B33", marginBottom: 8, fontFamily: "'Cormorant Garamond', Georgia, serif" }}>Something went wrong</div>
            <div style={{ fontSize: 14, color: "#7A8BA0", lineHeight: 1.6, marginBottom: 24 }}>
              An unexpected error occurred. Please try refreshing the page.
            </div>
            {process.env.REACT_APP_ENV !== "production" && this.state.error && (
              <div style={{
                background: "#FEF2F2", border: "1px solid #B91C1C40", borderRadius: 8,
                padding: 16, marginBottom: 20, textAlign: "left",
              }}>
                <div style={{ fontSize: 11, fontFamily: "'JetBrains Mono', monospace", color: "#B91C1C", wordBreak: "break-all" }}>
                  {this.state.error.toString()}
                </div>
              </div>
            )}
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "12px 32px", background: "linear-gradient(135deg, #0C1B33, #1A3260)", border: "none",
                color: "#D4AB52", fontSize: 14, fontWeight: 700, cursor: "pointer",
                letterSpacing: "0.5px",
              }}
            >Refresh Page</button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
